import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import '@maersk-global/mds-components-core/mc-input';
import '@maersk-global/mds-components-core/mc-select';
import '@maersk-global/mds-components-core/mc-multi-select';
import '@maersk-global/mds-components-core/mc-button';
import '@maersk-global/mds-components-core/mc-checkbox';
import { RepairCodeFilterForm } from '../../../form-model/repair-code-filter.form.model';
import { RepairCodeService } from '../../../services/repair-code.service';
import { firstValueFrom } from 'rxjs';
import { AemsMultilineTagInputComponent } from '../../../shared-components/aems-multiline-tag-input/aems-multiline-tag-input.component';
import { RegexConstants } from '../../../RegexConstants';

@Component({
  selector: 'app-repair-code-advanced-filter',
  imports: [CommonModule, ReactiveFormsModule, AemsMultilineTagInputComponent],
  templateUrl: './repair-code-advanced-filter.component.html',
  styleUrl: './repair-code-advanced-filter.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RepairCodeAdvancedFilterComponent implements OnInit {
  @Input({ required: true }) repairCodeFilterForm!: FormGroup<RepairCodeFilterForm>;
  @Input() bindMultiSelects: boolean = false;

  modeOptions: string[] = [];
  isLoadingModes = false;
  repairCodeRegex = RegexConstants.REPAIR_CODE;

  constructor(
    private readonly repairCodeService: RepairCodeService,
    private readonly formBuilder: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.addControlsToFormGroup();
    this.loadFilterOptions();
  }

  private addControlsToFormGroup(): void {
    const form = this.repairCodeFilterForm;
    if (!form.get('repairModeList')) {
      form.addControl('repairModeList', this.formBuilder.control<string[] | null>(null));
    }
    if (!form.get('repairCodeList')) {
      form.addControl('repairCodeList', this.formBuilder.control<string[]>([]));
    }
    if (!form.get('description')) {
      form.addControl('description', this.formBuilder.control<string | null>(null));
    }
    if (!form.get('isActive')) {
      form.addControl('isActive', this.formBuilder.control<string[]>([]));
    }
    if (!form.get('allowParts')) {
      form.addControl('allowParts', this.formBuilder.control<string[]>([]));
    }
    if (!form.get('multipleEq')) {
      form.addControl('multipleEq', this.formBuilder.control<string[]>([]));
    }
  }

  private async loadFilterOptions(): Promise<void> {
    this.isLoadingModes = true;
    try {
      this.modeOptions = await firstValueFrom(this.repairCodeService.getAllModes());
    } catch {
      this.modeOptions = [];
    } finally {
      this.isLoadingModes = false;
    }
  }

  isValueSelected(controlName: 'isActive' | 'allowParts' | 'multipleEq', value: string): boolean {
    const currentValues: string[] = this.repairCodeFilterForm.get(controlName)?.value || [];
    return currentValues.includes(value);
  }

  onCheckChange(controlName: 'isActive' | 'allowParts' | 'multipleEq', value: string): void {
    const control = this.repairCodeFilterForm.get(controlName);
    const currentValues: string[] = control?.value || [];
    if (currentValues.includes(value)) {
      const newValues = currentValues.filter((v) => v !== value);
      control?.setValue(newValues);
    } else {
      control?.setValue([...currentValues, value]);
    }
  }

  applyFilters(): void {
    this.repairCodeFilterForm.get('applyRepairCodeFilter')?.setValue(true);
  }

  clearFilters(): void {
    this.repairCodeFilterForm.reset({ repairCodeList: [], isActive: [], allowParts: [], multipleEq: [] });
    this.repairCodeFilterForm.get('applyRepairCodeFilter')?.setValue(true);
  }
}
